import React, { useState, useEffect } from "react";
import { fetchSettings } from "../../redux/slices/settingsSlice";
import { useDispatch, useSelector } from "react-redux";
import API from "../../api";

const Banner = ({ title, description }) => {
  const dispatch = useDispatch();
  let bannerImg = "";
  const { dataSettings } = useSelector((state) => state.settings);

  useEffect(() => {
    dispatch(fetchSettings());
  }, [dispatch]);

  if (dataSettings && dataSettings.banner) {
    bannerImg = `${API.BASE}${dataSettings.banner}` || "";
  }
  return (
    <div className="banner">
      <img src={bannerImg} alt="" />
      <div className="slogan">
        <div>
          <strong className="f40 fw400 color3">{title}</strong>
        </div>
        <div className="mt-2">
          <span className="f20 fw500 color3">{description}</span>
        </div>
      </div>
    </div>
  );
};

export default Banner;
